export const firebaseConfig = {
  apiKey: 'AIzaSyCVcL9o8psXk6BGfc5P8pUvZuQJoGTmJa8',
  authDomain: 'agamasac-gas-station-dev.firebaseapp.com',
  projectId: 'agamasac-gas-station-dev',
  storageBucket: 'agamasac-gas-station-dev.appspot.com',
  messagingSenderId: '909326836929',
  appId: '1:909326836929:web:90cba9d62954f98181e040',
  measurementId: 'G-7PLM8FQ845',
}
